import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { ErrorService } from 'src/app/services/errorService/error.service';

export const roleGuard: CanActivateFn = (route, state) => {
  const crypto = inject(CryptoService);
  const router = inject(Router);
  const errorService = inject(ErrorService);
  const ISCORPTRAVELARRANGER = crypto.getValueFromKey("ISCORPTRAVELARRANGER");
  const USERID = crypto.getValueFromKey("USERID");
  const SUBAGENTID = crypto.getValueFromKey("SUBAGENTID");
  const SABRANCHID = crypto.getValueFromKey("SABRANCHID");
  const COMPID = crypto.getValueFromKey("COMPID");
  const isLoggedIn = USERID && SUBAGENTID && SABRANCHID && COMPID;

  // Allow only if ISCORPTRAVELARRANGER is 0 or 1
  const isValidRole = ISCORPTRAVELARRANGER === '0';

  if (isLoggedIn && isValidRole) {
    return true;
  }
  errorService.setError('You are not authorized to access this resource.', 401, window.location.href);
  return router.createUrlTree(['/error']);
  return false;
  // this.error.setError('something get Wrong', error.status, window.location.href)
  // this.router.navigate(['/payment/error']);

  // return router.createUrlTree(['/login']);
};